import Immutable from 'seamless-immutable';
import _ from 'lodash';
import _head from 'lodash/head';

/**
 * Sharing Config
 * @typedef {object} Sharing Config
 *
 * @property {string} context the sharing context e.g. 'campaign'
 * @property {string} action the action to take e.g. 'share'
 * @property {string} network the social network to share with
 * @property {bool} isDefault is this the default sharing config i.e. the experience sharing config
 * @property {bool} enabled is this sharing option enabled?
 * @property {object} data the configuration of the sharing details e.g. tweet, facebook title, desc, image etc
 */

function create(sharingConfig = {}) {
  const result = _.clone(sharingConfig);
  return Immutable(result, { prototype: model });
}

/**
 * Transforms a backend sharing config object into a frontend SharingConfig Model
 * @param {Object} sharingConfig - backend formatted sharingConfig
 * @returns {SharingConfig}
 */
function deserialize(sharing, sharingConfig, id) {
  const result = _.pick(sharingConfig, _keys);

  // keep the object key for later serialisation
  result.id = id;

  // we seem to have been saving strings here. not sure why but this will correct
  if (result.enabled === 'false') result.enabled = false;
  if (result.enabled === 'true') result.enabled = true;

  // for the macro experience and mx it have different shape on the surrounding param
  result.data = _.isArray(sharingConfig.data) ? _head(result.data) : sharingConfig.data;

  // key the resulting model on a uid of our own making
  const _uid = `${result.context}:${result.action}:${result.network}`;
  sharing[_uid] = create(result, model);

  return sharing;
}

/**
 * Transform a SharingConfigModel into a backend sharingConfig object
 * @returns {Object}
 */
function serialize(sharing, sharingConfig, id) {
  const result = sharingConfig;

  const _key = result.id;
  delete result.id;

  // transform data back into an array
  result.data = [result.data];

  const _result = _.pick(result, _keys);

  sharing[_key] = _result;

  return sharing;
}

const model = {};

const _keys = ['context', 'action', 'network', 'isDefault', 'enabled', 'data'];

export default {
  create,
  deserialize,
  serialize,
};
